import { useFeatureFlags } from 'src/components/common/featureFlag/useFeatureFlags';
import { useSecondaryNavigationPermissions } from 'src/components/common/SecondaryNavigation/useSecondaryNavigationPermissions';
import { useSmartformPermissionHelper } from 'src/components/smartforms/useSmartformPermissionHelper';
import { useTaeFlags } from './TimesheetSettings/useTaeFlags';
import { isSecondaryNavGroup } from 'src/components/common/SecondaryNavigation/utils/guards';
import {
  SecondaryNavGroup,
  SecondaryNavItem
} from 'src/components/common/SecondaryNavigation/SecondaryNavigation.types';
import cloneDeep from 'lodash-es/cloneDeep';
import { withNestedRoutePath } from 'src/components/common/SecondaryNavigation/utils/getNavigationItemPath';
import { useGetSettingsNavItems } from './SettingsNavItems';

export function useSettingsNavItems() {
  const hasPermissions = useSecondaryNavigationPermissions();
  const { helperEnabled } = useSmartformPermissionHelper();
  const { isEnabled } = useFeatureFlags();
  const {
    tae,
    invoices: { enabled: invoicesEnabled, v2, newSettingsPage: newInvoicesSettingsPage }
  } = useTaeFlags();
  const isProgramAlertsEnabled = isEnabled('program-alerts-detection');

  return useGetSettingsNavItems({
    tae,
    isProgramAlertsEnabled,
    invoices: invoicesEnabled,
    invoicesV2: !!v2,
    newInvoicesSettingsPage
  }).filter((item) => {
    if (!isSecondaryNavGroup(item) && item.path === 'locations') {
      return false;
    }
    return helperEnabled || hasPermissions(item);
  });
}

export function toFlatRoutes(routes: (SecondaryNavItem | SecondaryNavGroup)[]): SecondaryNavItem[] {
  const copy = cloneDeep(routes);
  const target: SecondaryNavItem[] = [];

  while (!!copy.length) {
    const currentRoute = copy.shift();
    if (!currentRoute) {
      continue;
    }
    if ('path' in currentRoute) {
      target.push({ ...currentRoute });
    } else {
      copy.unshift(
        ...currentRoute.items.map((subroute) => {
          return withNestedRoutePath(currentRoute, subroute);
        })
      );
    }
  }
  return target;
}
